import fetchAPI from '../../../../../../../../lib/utils/fetch-api'

interface EditPaymentProps {
  date: string,
  sum: number,
}

export const editPayment = async (id: string | number, formData: EditPaymentProps, signal: AbortSignal) => {
  try {
    return await fetchAPI(`/api/case/payment/${id}`, {
      method: 'POST',
      body: JSON.stringify(formData),
      signal,
    })
      .then(response => {
        if (response['errors']) {
          let error = response['errors']
          if (Array.isArray(error)) {
            error = error.join()
          }
          throw new Error(error)
        }
        return response
      })
    .catch(err => {
      throw err
    })
  } catch (err) {
    throw err
  }
}
